import { cn } from '@quadralize/utils'
import { AddCircle, Bolt, Logout } from '@solar-icons/react'
import { useTranslation } from 'react-i18next'
import { useAppSidebar } from './use-app-sidebar'

export function AppSidebar() {
  const { t } = useTranslation('play')
  const { sections, loggedIn, userName, userInitials, handleNavigate, handleSignOut } =
    useAppSidebar()

  return (
    <aside className="hidden w-60 shrink-0 flex-col gap-2 border-r border-neutral-800 bg-neutral-950 px-4 py-5 md:flex">
      <div className="mb-2.5 flex items-center gap-2.5 border-b border-neutral-800 px-2.5 pb-4.5 pt-1.5">
        <span className="flex h-8.5 w-8.5 shrink-0 items-center justify-center rounded-xl bg-primary font-display text-lg font-bold text-neutral-0">
          P
        </span>
        <span className="min-w-0">
          <span className="block truncate font-display text-lg font-bold tracking-tight text-neutral-0">
            {t('brand.name')}
          </span>
          <span className="block truncate text-xs font-semibold uppercase tracking-wide text-neutral-400">
            {t('brand.tagline')}
          </span>
        </span>
      </div>

      <nav className="flex flex-1 flex-col gap-2 overflow-y-auto">
        {sections.map((section) => (
          <div key={section.label}>
            <p className="px-3 pb-1.5 pt-2.5 text-xs font-bold uppercase tracking-widest text-neutral-500">
              {section.label}
            </p>
            <ul className="flex flex-col gap-1">
              {section.items.map((item) => {
                const ItemIcon = item.icon
                return (
                  <li key={item.path}>
                    <button
                      type="button"
                      onClick={() => handleNavigate(item.path)}
                      aria-current={item.active ? 'page' : undefined}
                      className={cn(
                        'flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2.5 text-left text-sm font-medium transition-colors',
                        item.active
                          ? 'bg-primary font-semibold text-neutral-0 shadow-lg shadow-primary/50'
                          : 'text-neutral-300 hover:bg-neutral-900 hover:text-neutral-0',
                      )}
                    >
                      <ItemIcon
                        className="h-4.5 w-4.5 shrink-0"
                        weight={item.active ? 'Bold' : 'Linear'}
                      />
                      {item.label}
                    </button>
                  </li>
                )
              })}
            </ul>
          </div>
        ))}
      </nav>

      {loggedIn ? (
        <div className="mt-auto flex items-center gap-2 rounded-xl bg-neutral-900 p-2.5">
          <button
            type="button"
            onClick={() => handleNavigate('/conta')}
            className="flex min-w-0 flex-1 cursor-pointer items-center gap-2.5 text-left"
          >
            <span className="flex h-8.5 w-8.5 shrink-0 items-center justify-center rounded-xl bg-primary font-display text-sm font-bold text-neutral-0">
              {userInitials}
            </span>
            <span className="min-w-0">
              <span className="block truncate text-xs font-semibold text-neutral-0">
                {userName}
              </span>
              <span className="block truncate text-xs text-neutral-500">{t('nav.myAccount')}</span>
            </span>
          </button>
          <button
            type="button"
            onClick={handleSignOut}
            aria-label={t('nav.signOut')}
            className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg text-neutral-500 transition-colors hover:bg-neutral-800 hover:text-neutral-0"
          >
            <Logout className="h-4 w-4" />
          </button>
        </div>
      ) : (
        <div className="mt-auto flex flex-col gap-2">
          <button
            type="button"
            onClick={() => handleNavigate('/entrar')}
            className="flex cursor-pointer items-center justify-center gap-1.5 rounded-xl bg-primary px-3.5 py-2.5 text-sm font-semibold text-neutral-0 transition-colors hover:bg-primary-hover"
          >
            <Bolt className="h-3.5 w-3.5" weight="Bold" />
            {t('nav.signIn')}
          </button>
          <button
            type="button"
            onClick={() => handleNavigate('/cadastro')}
            className="flex cursor-pointer items-center justify-center gap-1.5 rounded-xl bg-neutral-800 px-3.5 py-2.5 text-sm font-semibold text-neutral-300 transition-colors hover:bg-neutral-700 hover:text-neutral-0"
          >
            <AddCircle className="h-3.5 w-3.5" />
            {t('nav.createAccount')}
          </button>
        </div>
      )}
    </aside>
  )
}
